import React from 'react';
import Icon from './Icon';

export default class IconArrowDown extends Icon {

    renderIcon() {
        const color = this.props.color ? this.props.color : (this.state.hover ? '#ec6b05' : '#A6ACAF')
        return (
            <svg width={this.getSize()} height={this.getSize()} viewBox="0 0 14 14">
                <path fill={color} style={{transform: 'translate(1px, 1px)'}}
                      d="M11.606 3.599l-.386-.389a.64.64 0 0 0-.457-.188.641.641 0 0 0-.456.188L5.9 7.617 1.488 3.205a.64.64 0 0 0-.457-.188.64.64 0 0 0-.456.188l-.386.387a.646.646 0 0 0 0 .912l5.253 5.272a.66.66 0 0 0 .457.207h.002a.66.66 0 0 0 .457-.207l5.248-5.258a.652.652 0 0 0 0-.919z"></path>
            </svg>
        )
    }
}